import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { fetchTranslations } from "../actions/languageActions";
import NewHeader from "../components/Header/NewHeader";
import Footer from "../components/Footer/Footer";
import Loading from "../components/loading/Loading";

const SignetForms = () => {
  const [activeForm, setActiveForm] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 650);
  }, []);

  const dispatch = useDispatch();
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  const translations = useSelector((state) => state.language.translations[selectedLanguage]);

  useEffect(() => {
    dispatch(fetchTranslations(selectedLanguage));
  }, [dispatch, selectedLanguage]);

  if (!translations) {
    return <Loading />;
  }

  const { forms } = translations;

  return (
    <>
      <Helmet>
        <title>Forms - Signet Institute | Certificate & Diploma Courses in Australia</title>
        <meta
          name="description"
          content="Discover a wide range of forms & applications at Signet Institute. Submit (Online Forms) requests, applications inquiries efficiently."
          data-rh="true"
        />
      </Helmet>

      <NewHeader />

      <div className="container pt-140">
        <div className="text-center mb-4">
            <div className="row">
                <h3>Select Campus</h3>
                <div className="col-md-4">
                    <div className="d-flex flex-column align-items-center gap-1 mb-3">
                        <button style={{
                            width: '100%',
                            backgroundColor: activeForm === 1 ? 'black' : '', // <-- added
                            color: activeForm === 1 ? 'white' : '', // <-- optional for contrast
                        }}
                            className={`theme-btn my-15 ${activeForm === 1 ? 'active' : ''}`}
                            onClick={() => setActiveForm(1)}
                        >
                            Adelaide
                        </button>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="d-flex flex-column align-items-center gap-1 mb-3">
                        <button style={{
                            width: '100%',
                            backgroundColor: activeForm === 2 ? 'black' : '', // <-- added
                            color: activeForm === 2 ? 'white' : '', // <-- optional for contrast
                        }} 
                            className={`theme-btn my-15 ${activeForm === 2 ? 'active' : ''}`}
                            onClick={() => setActiveForm(2)}
                        >
                            Melbourne
                        </button>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="d-flex flex-column align-items-center gap-1 mb-3">
                        <button style={{
                            width: '100%',
                            backgroundColor: activeForm === 3 ? 'black' : '', // <-- added
                            color: activeForm === 3 ? 'white' : '', // <-- optional for contrast
                        }}
                            className={`theme-btn my-15 ${activeForm === 3 ? 'active' : ''}`}
                            onClick={() => setActiveForm(3)}
                        >
                            Sydney
                        </button>
                    </div>
                </div>
            </div>
        </div>      

        <div className="row justify-content-center">
            <div className="col-12">
                {activeForm === 1 && (
                <div className="row">
                    <h3 className="text-center">Adelaide</h3>
                    <div className="col-lg-4 col-md-12">
                        <a href="https://zfrmz.com.au/6vftQYj1slblcukBlw9G" className="theme-btn my-15" style={{ width: '100%' }}>Credit Transfer</a>
                        <a href="https://zfrmz.com.au/cz1Zra2yak2e8BXKa105" className="theme-btn my-15" style={{ width: '100%' }}>Deferment</a>
                        <a href="https://zfrmz.com.au/6vftQYj1slblcukBlw9G" className="theme-btn my-15" style={{ width: '100%' }}>Student Survey</a>
                        <a href="https://zfrmz.com.au/g94C5IsRokwCg9620btJ" className="theme-btn my-15" style={{ width: '100%' }}>Enrolment Letter</a>
                        <a href="https://zfrmz.com.au/tJH8XyZLJ2pnZlj3ZRrN" className="theme-btn my-15" style={{ width: '100%' }}>ID Card Printing</a>
                        <a href="https://zfrmz.com.au/KRYP2BtKxAH6ODOGC7HB" className="theme-btn my-15" style={{ width: '100%' }}>Completion Certificate</a>
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <a href="https://zfrmz.com.au/nB0s8CoRj6qsd6oJuDyB" className="theme-btn my-15" style={{ width: '100%' }}>Withdrawal</a>
                        <a href="https://zfrmz.com.au/Z8MGt1AnwR1up1VLmTDJ" className="theme-btn my-15" style={{ width: '100%' }}>Leave Request</a>
                        <a href="https://zfrmz.com.au/sBe8EkfAmV1py57WoNeF" className="theme-btn my-15" style={{ width: '100%' }}>Re-enrolment</a>
                        <a href="https://zfrmz.com.au/YLMUGlXB4D5sT8hPHAO5" className="theme-btn my-15" style={{ width: '100%' }}>Course Transfer</a>
                        <a href="https://zfrmz.com.au/zCv8QlTE6udewM6EwdHy" className="theme-btn my-15" style={{ width: '100%' }}>COE Extension</a>
                        <a href="https://zfrmz.com.au/H1xpt5Fzr6pBvcrfw5Oi" className="theme-btn my-15" style={{ width: '100%' }}>Statement of Account</a>
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <a href="https://zfrmz.com.au/ojSA4aqWUsBvmw790fTz" className="theme-btn my-15" style={{ width: '100%' }}>Campus Change</a>
                        <a href="https://zfrmz.com.au/ka8RFcoBCIt2Ob5FEAoJ" className="theme-btn my-15" style={{ width: '100%' }}>Change of Student Details</a>
                        <a href="https://zfrmz.com.au/l8WXsw9Qcld4g7mEgCwJ" className="theme-btn my-15" style={{ width: '100%' }}>Complaint</a>
                        <a href="https://zfrmz.com.au/P623CoiKGFVerkMtzTdp" className="theme-btn my-15" style={{ width: '100%' }}>Course Progress</a>
                        <a href="https://zfrmz.com.au/CH67XryLk40nmeO7KJeB" className="theme-btn my-15" style={{ width: '100%' }}>Refund</a>
                    </div>
                </div>
                )}
            </div>
            <div className="col-12">
                {activeForm === 2 && (
                <div className="row">
                    <h3 className="text-center">Melbourne</h3>
                    <div className="col-lg-4 col-md-12">
                        <a href="https://zfrmz.com.au/t3n867tTowiBsaCc5Oy8" className="theme-btn my-15" style={{ width: '100%' }}>Credit Transfer</a>
                        <a href="https://zfrmz.com.au/DxbrikdOBlcvzuixyL6f" className="theme-btn my-15" style={{ width: '100%' }}>Deferment</a>
                        <a href="https://zfrmz.com.au/HrPTYbOpzpBsgW4NriPR" className="theme-btn my-15" style={{ width: '100%' }}>Student Survey</a>
                        <a href="https://zfrmz.com.au/uZTZbHnHwKtcvVpniQqx" className="theme-btn my-15" style={{ width: '100%' }}>Enrolment Letter</a>
                        <a href="https://zfrmz.com.au/Zygo4qEwYn3th9lhGjT0" className="theme-btn my-15" style={{ width: '100%' }}>ID Card Printing</a>
                        <a href="https://zfrmz.com.au/jgTtS8k5adugaX5umqvh" className="theme-btn my-15" style={{ width: '100%' }}>Completion Certificate</a>
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <a href="https://zfrmz.com.au/LjJ4NpucrAdV6Z25a2IC" className="theme-btn my-15" style={{ width: '100%' }}>Withdrawal</a>
                        <a href="https://zfrmz.com.au/2aEpek1Zi7gIUtJOgw5Z" className="theme-btn my-15" style={{ width: '100%' }}>Leave Request</a>
                        <a href="https://zfrmz.com.au/eoGGDkMksMW5oIDtD5pm" className="theme-btn my-15" style={{ width: '100%' }}>Re-enrolment</a>
                        <a href="https://zfrmz.com.au/42QXCzPDj8eAQKPVSbDp" className="theme-btn my-15" style={{ width: '100%' }}>Course Transfer</a>
                        <a href="https://zfrmz.com.au/3FVgWLAHN8Q7NFw9jvNu" className="theme-btn my-15" style={{ width: '100%' }}>COE Extension</a>
                        <a href="https://zfrmz.com.au/H1xpt5Fzr6pBvcrfw5Oi" className="theme-btn my-15" style={{ width: '100%' }}>Statement of Account</a>
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <a href="https://zfrmz.com.au/fszg7IFLQV3V2dapvmIX" className="theme-btn my-15" style={{ width: '100%' }}>Campus Change</a>
                        <a href="https://zfrmz.com.au/HBP8b6kgN7FzlZ8jv6Dq" className="theme-btn my-15" style={{ width: '100%' }}>Change of Student Details</a>
                        <a href="https://zfrmz.com.au/5TQ63PCHoVQEujToarxF" className="theme-btn my-15" style={{ width: '100%' }}>Complaint</a>
                        <a href="https://zfrmz.com.au/JKdUOExG6MDa2IeaQogS" className="theme-btn my-15" style={{ width: '100%' }}>Course Progress</a>
                        <a href="https://zfrmz.com.au/OZ1D1d0yjLmV5OAqjCrC" className="theme-btn my-15" style={{ width: '100%' }}>Refund</a>
                    </div>
                </div>
                )}
            </div>
            <div className="col-12">
                {activeForm === 3 && (
                <div className="row">
                    <h3 className="text-center">Sydney</h3>
                    <div className="col-lg-4 col-md-12">
                        <a href="https://zfrmz.com.au/d8N56CE6NB12bCykRG8G" className="theme-btn my-15" style={{ width: '100%' }}>Credit Transfer</a>
                        <a href="https://zfrmz.com.au/BmkBMq6AdrfjbzImSBpB" className="theme-btn my-15" style={{ width: '100%' }}>Deferment</a>
                        <a href="https://zfrmz.com.au/HrPTYbOpzpBsgW4NriPR" className="theme-btn my-15" style={{ width: '100%' }}>Student Survey</a>
                        <a href="https://zfrmz.com.au/SsE23qWjfXCkipHsotaH" className="theme-btn my-15" style={{ width: '100%' }}>Enrolment Letter</a>
                        <a href="https://zfrmz.com.au/XQHjrYF10CDC2KuElFBm" className="theme-btn my-15" style={{ width: '100%' }}>ID Card Printing</a>
                        <a href="https://zfrmz.com.au/brKVYXmDJLP6fV13h3uq" className="theme-btn my-15" style={{ width: '100%' }}>Completion Certificate</a>
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <a href="https://zfrmz.com.au/0HwTZzupKhqKTyh1Bq6E" className="theme-btn my-15" style={{ width: '100%' }}>Withdrawal</a>
                        <a href="https://zfrmz.com.au/ME6YAMHx4K2USjSpmn4K" className="theme-btn my-15" style={{ width: '100%' }}>Leave Request</a>
                        <a href="https://zfrmz.com.au/nJiuPLExCwz6qIlgNQSt" className="theme-btn my-15" style={{ width: '100%' }}>Re-enrolment</a>
                        <a href="https://zfrmz.com.au/1xiE2qrmgP8YoH3WQxkz" className="theme-btn my-15" style={{ width: '100%' }}>Course Transfer</a>
                        <a href="https://zfrmz.com.au/4gdw7S8LxqLv8MpwQhkV" className="theme-btn my-15" style={{ width: '100%' }}>COE Extension</a>
                        <a href="https://zfrmz.com.au/H1xpt5Fzr6pBvcrfw5Oi" className="theme-btn my-15" style={{ width: '100%' }}>Statement of Account</a>
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <a href="https://zfrmz.com.au/WQR91g4UAqsRCbQ7UV35" className="theme-btn my-15" style={{ width: '100%' }}>Campus Change</a>
                        <a href="https://zfrmz.com.au/lNThXfeEPr6eP7Fzf7Qx" className="theme-btn my-15" style={{ width: '100%' }}>Change of Student Details</a>
                        <a href="https://zfrmz.com.au/sE8qorgIrA9INlfmeqDi" className="theme-btn my-15" style={{ width: '100%' }}>Complaint</a>
                        <a href="https://zfrmz.com.au/hYXni9o1aWMBeOlCap7R" className="theme-btn my-15" style={{ width: '100%' }}>Course Progress</a>
                        <a href="https://zfrmz.com.au/qRKG1UcAhJUQ5ZsOq6IB" className="theme-btn my-15" style={{ width: '100%' }}>Refund</a>
                    </div>
                </div>
                )}
            </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default SignetForms;